import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);
  
  // Images from art folder
  const artImages = [
    '/images/art/photo_1_2025-12-19_09-25-02.jpg',
    '/images/art/photo_2_2025-12-19_09-25-02.jpg',
    '/images/art/photo_3_2025-12-19_09-25-02.jpg',
  ];

  // Images from formation folder
  const formationImages = [
    '/images/formation/photo_11_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_20_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_21_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_25_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_26_2025-12-19_08-37-19.jpg',
  ];

  // Images from about folder
  const aboutImages = [
    '/images/about/photo_12_2025-12-19_08-37-19.jpg',
    '/images/about/photo_15_2025-12-19_08-37-19.jpg',
  ];

  // Images from image_new folder for About section
  const imageNewImages = [
    '/images/image_new/photo_1_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_1_2025-12-19_08-38-16.jpg',
    '/images/image_new/photo_10_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_11_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_12_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_13_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_14_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_15_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_16_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_17_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_18_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_19_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_2_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_2_2025-12-19_08-38-16.jpg',
    '/images/image_new/photo_20_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_21_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_22_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_23_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_24_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_25_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_26_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_3_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_3_2025-12-19_08-38-16.jpg',
    '/images/image_new/photo_4_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_4_2025-12-19_08-38-16.jpg',
    '/images/image_new/photo_5_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_5_2025-12-19_08-38-16.jpg',
    '/images/image_new/photo_6_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_7_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_8_2025-12-19_08-37-19.jpg',
    '/images/image_new/photo_9_2025-12-19_08-37-19.jpg',
  ];

  // Function to get random image from a category
  const getRandomImage = (categoryImages) => {
    if (categoryImages.length === 0) return '';
    const shuffled = [...categoryImages].sort(() => 0.5 - Math.random());
    return shuffled[0];
  };

  // Map services to gallery categories
  const serviceToGalleryMap = {
    'formation': 1, // Formation Manucure
    'nail-art': 2,  // Nail Art
    'manicure': 3,  // Manicure Classique
    'pedicure': 4   // Pédicure
  };
  
  const handleServiceImageClick = (serviceType) => {
    const categoryId = serviceToGalleryMap[serviceType];
    if (categoryId) {
      navigate(`/gallery?category=${categoryId}`);
    }
  };

  // State for random carousel images
  const [carouselImages, setCarouselImages] = useState({
    art: getRandomImage(artImages),
    formation: getRandomImage(formationImages),
    about: getRandomImage(aboutImages)
  });

  // State for random images in About section (from image_new)
  const [aboutRandomImages, setAboutRandomImages] = useState(() => {
    const shuffled = [...imageNewImages].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 4);
  });

  // Change carousel image when slide changes
  useEffect(() => {
    const updateImageForSlide = () => {
      if (activeSlide === 0) {
        // Art slide
        setCarouselImages(prev => ({
          ...prev,
          art: getRandomImage(artImages)
        }));
      } else if (activeSlide === 1) {
        // Formation slide
        setCarouselImages(prev => ({
          ...prev,
          formation: getRandomImage(formationImages)
        }));
      } else if (activeSlide === 2) {
        // About slide
        setCarouselImages(prev => ({
          ...prev,
          about: getRandomImage(aboutImages)
        }));
      }
    };

    updateImageForSlide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSlide]);

  // Change About section images every 5 seconds (from image_new)
  useEffect(() => {
    const getRandomImages = () => {
      const shuffled = [...imageNewImages].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, 4);
    };
    
    const interval = setInterval(() => {
      setAboutRandomImages(getRandomImages());
    }, 5000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const slides = [
    {
      image: carouselImages.art,
      title: 'Art & Perfection',
      description: 'Bienvenue dans l\'art de la perfection. En tant que prothésiste ongulaire certifiée, je suis spécialisée dans les manucures élégantes, le façonnage précis et une beauté durable. Que vous recherchiez une sophistication classique ou un nail art audacieux, je mets créativité et soin dans chaque pose.',
      alt: 'Art'
    },
    {
      image: carouselImages.formation,
      title: 'Manicure Formation | Trainer',
      description: 'Apprenez les techniques professionnelles et développez votre talent avec nos formations spécialisées.',
      alt: 'Formation Pro'
    },
    {
      image: carouselImages.about,
      title: 'Éducation & Perfectionnement',
      description: 'Des formations de base à l\'expertise avancée — pour élever votre art à un niveau supérieur.',
      alt: 'About'
    }
  ];

  // Auto-play carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setActiveSlide(index);
  };

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      <Helmet>
        <title>Royal Nails Pro | Geneva Manucure et pédicure professionnelles</title>
        <link rel="canonical" href="https://royalnailspro.ch" />
        <meta
          name="description"
          content="Royal Nails Pro – salon de manucure professionnel à Genève offrant manucure classique, ongles en gel, extensions, pédicure spa, nail art et soins des ongles haut de gamme pour un résultat parfait."
        />
        <meta
          name="keywords"
          content="manucure Genève, pédicure Genève, nail art Genève, ongles gel Genève, salon ongles Genève, formation manucure, manucure russe, extensions ongles, soins ongles Genève, Royal Nails Pro, salon beauté Genève, prothésiste ongulaire Genève, manucure professionnelle, pédicure professionnelle, nail art design, ongles acrylique, spa ongles, soins mains pieds Genève"
        />
        
        {/* Open Graph / Facebook & Instagram */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://royalnailspro.ch" />
        <meta property="og:title" content="Royal Nails Pro | Geneva Manucure et pédicure professionnelles" />
        <meta property="og:description" content="Salon de manucure professionnel à Genève offrant manucure classique, ongles en gel, extensions, pédicure spa, nail art et soins des ongles haut de gamme." />
        <meta property="og:image" content="https://royalnailspro.ch/images/logo.png" />
        <meta property="og:image:secure_url" content="https://royalnailspro.ch/images/logo.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Royal Nails Pro - Salon de manucure professionnel Genève" />
        <meta property="og:locale" content="fr_CH" />
        <meta property="og:locale:alternate" content="en_US" />
        <meta property="og:site_name" content="Royal Nails Pro" />
        <meta property="fb:app_id" content="" />
        <meta property="article:author" content="https://www.facebook.com/people/Rodyka-Soltan/61572131475024/" />
        
        {/* Instagram specific */}
        <meta property="instagram:creator" content="@rodyka_soltan" />
        
        {/* TikTok */}
        <meta name="tiktok:creator" content="@rodicasoltan" />
        <meta name="tiktok:site" content="@rodicasoltan" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://royalnailspro.ch" />
        <meta name="twitter:title" content="Royal Nails Pro | Geneva Manucure et pédicure professionnelles" />
        <meta name="twitter:description" content="Salon de manucure professionnel à Genève offrant manucure classique, ongles en gel, extensions, pédicure spa, nail art et soins des ongles haut de gamme." />
        <meta name="twitter:image" content="https://royalnailspro.ch/images/logo.png" />
        <meta name="twitter:image:alt" content="Royal Nails Pro - Salon de manucure professionnel Genève" />
        <meta name="twitter:site" content="@rodyka_soltan" />
        <meta name="twitter:creator" content="@rodyka_soltan" />
        
        {/* Structured Data - LocalBusiness */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BeautySalon",
            "name": "Royal Nails Pro",
            "image": "https://royalnailspro.ch/images/logo.png",
            "description": "Salon de manucure professionnel à Genève offrant manucure classique, ongles en gel, extensions, pédicure spa, nail art et soins des ongles haut de gamme.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Avenue Pictet-de-Rochemont 19",
              "addressLocality": "Genève",
              "postalCode": "1207",
              "addressCountry": "CH"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "46.2044",
              "longitude": "6.1432"
            },
            "url": "https://royalnailspro.ch",
            "telephone": "+41783118784",
            "email": "roronails123@gmail.com",
            "priceRange": "$$",
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "09:00",
                "closes": "20:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "10:00",
                "closes": "20:00"
              }
            ],
            "sameAs": [
              "https://www.instagram.com/rodyka_soltan",
              "https://www.facebook.com/people/Rodyka-Soltan/61572131475024/",
              "https://www.tiktok.com/@rodicasoltan",
              "https://www.linkedin.com/in/soltan-rodyka-293704377"
            ]
          })}
        </script>
      </Helmet>

      <div className="container">
        <div className="back_re">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <h1>Royal Nails Pro – Créateurs de beauté</h1>
              </div>
            </div>
          </div>
        </div>

        {/* Banner - React Carousel */}
        <section className="banner_main">
          <div className="carousel slide banner_main" style={{ position: 'relative' }}>
            {/* Carousel Indicators */}
            <ol className="carousel-indicators" style={{ display: 'flex', justifyContent: 'center' }}>
              {slides.map((_, index) => (
                <li
                  key={index}
                  className={activeSlide === index ? 'active' : ''}
                  onClick={() => goToSlide(index)}
                  style={{ cursor: 'pointer' }}
                ></li>
              ))}
            </ol>

            {/* Carousel Slides */}
            <div className="carousel-inner">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`carousel-item ${activeSlide === index ? 'active' : ''}`}
                  style={{
                    display: activeSlide === index ? 'block' : 'none'
                  }}
                >
                <div className="container-fluid">
                  <div className="carousel-caption relative">
                    <div className="row d_flex">
                        {/* Desktop: Image on left */}
                        <div 
                          className="col-md-6 col-12 text-center mb-3 mb-md-0 carousel-image-container d-none d-md-flex"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '700px',
                            height: '700px',
                            padding: '20px'
                          }}
                        >
                          <img 
                            className="bann_img" 
                            src={slide.image} 
                            alt={slide.alt}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              maxWidth: '100%',
                              maxHeight: '100%'
                            }}
                          />
              </div>

                        {/* Mobile: Background image with text overlay */}
                        <div 
                          className="col-md-6 col-12 carousel-mobile-slide d-md-none"
                          style={{
                            position: 'relative',
                            minHeight: '600px',
                            height: '600px',
                            backgroundImage: `url(${slide.image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                          }}
                        >
                          {/* Overlay for text readability */}
                          <div
                            style={{
                              position: 'absolute',
                              bottom: 0,
                              left: 0,
                              right: 0,
                              background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.4), transparent)',
                              padding: '30px 20px 20px 20px',
                              zIndex: 2
                            }}
                          >
                            <h2 style={{ color: '#fff', marginBottom: '15px', textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>
                              {slide.title}
                            </h2>
                            <p style={{ color: '#fff', marginBottom: '20px', textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }}>
                              {slide.description}
                        </p>
                        <a
                          className="get_btn"
                          href="https://salonkee.ch/salon/soltan-rodyka-nails?lang=fr"
                          role="button"
                              style={{
                                display: 'inline-block',
                                padding: '12px 30px',
                                backgroundColor: '#6e2290',
                                color: '#fff',
                                textDecoration: 'none',
                                borderRadius: '32px',
                                fontSize: '17px',
                                fontWeight: '500',
                                textShadow: 'none'
                              }}
                        >
                          Book / Réserver
                        </a>
                </div>
              </div>

                        {/* Desktop: Text on right */}
                        <div className="col-md-6 col-12 d-none d-md-block">
                          <h2>{slide.title}</h2>
                          <p>{slide.description}</p>
                        <a
                          className="get_btn"
                          href="https://salonkee.ch/salon/soltan-rodyka-nails?lang=fr"
                          role="button"
                        >
                          Book / Réserver
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              ))}
            </div>

            {/* Controls */}
            <button
              className="carousel-control-prev"
              onClick={prevSlide}
              type="button"
              style={{ border: 'none', background: 'transparent' }}
            >
              <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              <span className="sr-only">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              onClick={nextSlide}
              type="button"
              style={{ border: 'none', background: 'transparent' }}
            >
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
              <span className="sr-only">Next</span>
            </button>
          </div>
        </section>
      </div>

      {/* What We Do */}
      <div className="we_do slin">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="titlepage">
                <h2>Nos Services</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-md-12">
              <div className="row">
                <div className="col-md-3 col-sm-6">
                  <div className="we_box">
                    <div 
                      className="circle-img" 
                      onClick={() => handleServiceImageClick('formation')}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src="/images/formation21.png" alt="Formation" />
                    </div>
                    <h3>FORMATION MANUCURE</h3>
                    <p>Formation professionnelle en techniques de manucure.</p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="we_box text-center">
                    <div 
                      className="circle-img"
                      onClick={() => handleServiceImageClick('nail-art')}
                      style={{ cursor: 'pointer' }}
                    >
                      <i>
                        <img src="/images/manic-12.png" alt="Nail Art" />
                      </i>
                    </div>
                    <h3>Nail Art</h3>
                    <p>FORMATION DE BASE MANUCURE RUSSE</p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="we_box text-center">
                    <div 
                      className="circle-img"
                      onClick={() => handleServiceImageClick('manicure')}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src="/images/manic_pers.png" alt="Manicure" />
                    </div>
                    <h3>Manicure</h3>
                    <p>Manicure et pose vernis Gel</p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="we_box">
                    <div 
                      className="circle-img"
                      onClick={() => handleServiceImageClick('pedicure')}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src="/images/ped-2.png" alt="Pedicure" />
                    </div>
                    <h3>Pedicure</h3>
                    <p>Pédicure hygiénique complète avec vernis semi permanent(gel)</p>
                  </div>
                </div>
                <div className="col-12 text-center mt-4">
                  <a className="read_more" href="/gallery">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About */}
      <div className="about slin2">
        <div className="container">
          <div className="row d_flex">
            <div className="col-md-6">
              <div className="titlepage">
                <h2>À propos</h2>
                <p>
                  Bienvenue chez Geneva Manucure – Royal Nails Pro, l'adresse incontournable pour des
                  ongles impeccables à Genève. Dans notre salon, l'art de la perfection est une
                  véritable signature. En tant que prothésiste ongulaire certifiée, je suis
                  spécialisée dans les manucures élégantes, le façonnage précis et une beauté durable.
                  Que vous souhaitiez une sophistication classique, un look naturel et soigné ou un
                  nail art audacieux, chaque prestation est réalisée avec créativité, minutie et
                  passion. Chez Geneva Manucure – Royal Nails Pro, vos mains méritent l'excellence —
                  et nous ne vous offrons rien de moins.
                </p>
                <a className="read_more" href="/about">
                  En savoir plus
                </a>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about_img">
                <figure>
                  <img src="/images/about.png" alt="apropos" />
                </figure>
              </div>
            </div>
          </div>
          
          {/* Random Images Row */}
          <div className="row mt-5">
            <div className="col-md-12">
              <div className="row">
                {aboutRandomImages.map((image, index) => (
                  <div key={`${image}-${index}`} className="col-md-3 col-sm-6 mb-4">
                    <div 
                      style={{
                        width: '100%',
                        height: '250px',
                        overflow: 'hidden',
                        borderRadius: '8px',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <img 
                        src={image} 
                        alt={`Gallery ${index + 1}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'opacity 0.5s ease'
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing */}
      <div className="pricing slin">
        <div className="container">
          <h2 className="section-title">Nos Offres & Services</h2>

          <div className="pricing-grid">
            {/* Promo 1 */}
            <div className="pricing_item">
              <div className="pricing_box_ti">
                <h3>
                  Manicure Promo <span>-15%</span>
                </h3>
              </div>
              <div className="our_pricing">
                <span>Offre limitée</span>
                <p>Profitez d'une remise exceptionnelle sur votre manucure classique.</p>
              </div>
              <a
                className="read_more mar_top"
                href="https://salonkee.ch/salon/soltan-rodyka-nails?lang=fr"
              >
                Reserver
              </a>
            </div>

            {/* Promo 2 */}
            <div className="pricing_item">
              <div className="pricing_box_ti">
                <h3>
                  Pedicure Promo <span>-15%</span>
                </h3>
              </div>
              <div className="our_pricing">
                <span>Offre saisonnière</span>
                <p>Relaxez-vous avec une pédicure professionnelle à prix réduit.</p>
              </div>
              <a
                className="read_more mar_top"
                href="https://salonkee.ch/salon/soltan-rodyka-nails?lang=fr"
              >
                Reserver
              </a>
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-center mt-4">
              <a className="read_more" href="/services">
                En savoir plus
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;

